import {disableButtons} from "./disableButtonsActions";

export const loginError = err => {
    return {
        type: 'LOGIN_ERROR',
        err
    }
};

export const userLogin = (user, pass, history) => {
    return dispatch => {
        dispatch(disableButtons(true));
        return fetch(`${process.env.REACT_APP_API_URL}/login/panel`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({
                username: user,
                password: pass
            })
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                }
            })
            .then(res => {
                dispatch(disableButtons(false));
                return res.token
            })
            .then(token => {
                sessionStorage.setItem('agronetToken', token);
                dispatch(disableButtons(false));
            })
            .then(() => sessionStorage.getItem('agronetToken')
                ? history.push('/sensor')
                : null
            )
            .catch(err => {
                dispatch(loginError('error'));
                dispatch(disableButtons(false));
            });
    }
};

export const setNewPassword = (pass, pass2, history) => {
    return dispatch => {
        dispatch(disableButtons(true));
        return fetch(`${process.env.REACT_APP_API_URL}/password/set`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('c19aToken')
            },
            body: JSON.stringify({
                password: pass
            })
        })
            .then(res => {
                if(res.status === 200) {
                    dispatch(approvePasswordChange(history))
                }
            })
            .catch(err => {
                dispatch(loginError('error'));
                dispatch(disableButtons(false));
            });
    }
};

export const approvePasswordChange = history => {
    return dispatch => {
        return fetch(`${process.env.REACT_APP_API_URL}/login_complete`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('c19aToken'),
            }
        })
            .then(res => {
                dispatch(disableButtons(false));
                if(res.status === 200) {
                    history.push('/login')
                }
            })
            .catch(err => {
                dispatch(loginError('error'));
                dispatch(disableButtons(false));
            });
    }
};
